// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.selection-bar {
  position: sticky;
  bottom: 0;
  margin: 0 -24px -24px;
  padding: 14px 24px;
  background: var(--ink-dark);
  color: var(--ink-text);
  display: flex;
  align-items: center;
  gap: 16px;
  box-shadow: 0 -8px 24px rgba(0, 0, 0, 0.18);
  z-index: 10;
}

.selection-bar__count {
  font-family: var(--mono);
  font-size: var(--fs-meta);
  color: var(--cream);
  letter-spacing: 0.05em;
}

.selection-bar__total {
  font-family: var(--display);
  font-size: var(--fs-prose);
  font-weight: 400;
  color: var(--ink-text);
  letter-spacing: -0.005em;
}

.selection-bar__qual {
  font-family: var(--mono);
  font-size: var(--fs-sm);
  color: var(--ink-text-3);
  margin-left: 6px;
}

.selection-bar__spacer {
  flex: 1;
}

.selection-bar__clear {
  background: transparent;
  border: 0;
  color: var(--ink-text-3);
  font-size: var(--fs-meta);
  cursor: pointer;
  text-decoration: underline;
  padding: 0;
}

.selection-bar__clear:hover {
  color: var(--ink-text);
}
`, "",{"version":3,"sources":["webpack://./src/ui/SelectionBar/SelectionBar.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,SAAS;EACT,qBAAqB;EACrB,kBAAkB;EAClB,2BAA2B;EAC3B,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,2CAA2C;EAC3C,WAAW;AACb;;AAEA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;EAC1B,gBAAgB;EAChB,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;EACxB,uBAAuB;EACvB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,uBAAuB;EACvB,SAAS;EACT,wBAAwB;EACxB,yBAAyB;EACzB,eAAe;EACf,0BAA0B;EAC1B,UAAU;AACZ;;AAEA;EACE,sBAAsB;AACxB","sourcesContent":[".selection-bar {\n  position: sticky;\n  bottom: 0;\n  margin: 0 -24px -24px;\n  padding: 14px 24px;\n  background: var(--ink-dark);\n  color: var(--ink-text);\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  box-shadow: 0 -8px 24px rgba(0, 0, 0, 0.18);\n  z-index: 10;\n}\n\n.selection-bar__count {\n  font-family: var(--mono);\n  font-size: var(--fs-meta);\n  color: var(--cream);\n  letter-spacing: 0.05em;\n}\n\n.selection-bar__total {\n  font-family: var(--display);\n  font-size: var(--fs-prose);\n  font-weight: 400;\n  color: var(--ink-text);\n  letter-spacing: -0.005em;\n}\n\n.selection-bar__qual {\n  font-family: var(--mono);\n  font-size: var(--fs-sm);\n  color: var(--ink-text-3);\n  margin-left: 6px;\n}\n\n.selection-bar__spacer {\n  flex: 1;\n}\n\n.selection-bar__clear {\n  background: transparent;\n  border: 0;\n  color: var(--ink-text-3);\n  font-size: var(--fs-meta);\n  cursor: pointer;\n  text-decoration: underline;\n  padding: 0;\n}\n\n.selection-bar__clear:hover {\n  color: var(--ink-text);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
